export class IncompleteRegistrationError extends Error {}
export class UnauthorizedUserError extends Error {}
export class DisabledUserError extends Error {}
export class InvalidAddressError extends Error {}
export class InvalidPhoneError extends Error {}
export class InvalidTerritoryError extends Error {}
export class InvalidCongregationError extends Error {}
export class InvalidGroupError extends Error {}
export class InvalidPublisherError extends Error {}
